import { hashKey, type Query, type QueryKey } from '@tanstack/react-query';

/**
 * Keep prior data only while an observer moves to a different query key.
 *
 * Identity hard-purges clear a mounted query in place so its observers can
 * refetch under the next viewer. TanStack's stock `keepPreviousData` also
 * preserves data when that same query is cleared, which can expose the prior
 * viewer through observer-local placeholder state. Comparing query hashes
 * preserves filter-transition continuity without crossing that privacy edge.
 */
export function keepPreviousDataAcrossQueryKeys<Data>(
  currentQueryKey: QueryKey,
  previousData: Data | undefined,
  previousQuery: Query<Data, Error, Data, QueryKey> | undefined,
): Data | undefined {
  if (previousQuery === undefined) return undefined;
  return previousQuery.queryHash === hashKey(currentQueryKey) ? undefined : previousData;
}
